import { movies } from "@/mocks/movies";
import SectionHeading from "./SectionHeading";
import MovieCard from "./MovieCard";

export default function HighRated() {
  const topRated = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 8);

  return (
    <section id="high-rated" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="高分电影精选"
            title="评分 8.5 分以上，闭眼也不会踩空"
            description="按综合评分从高到低排列。分数只是参考，真正的准则是它有没有讲好一个故事——下面这些，基本都做到了。"
          />
          <p className="flex items-center gap-2 rounded-md bg-secondary-100 px-4 py-3 font-label text-xs text-secondary-900 md:shrink-0">
            <i className="ri-information-line text-base"></i>
            评分用于横向比较，口味匹配更重要
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
          {topRated.map((movie, index) => (
            <MovieCard key={movie.id} movie={movie} rank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}